<!-- 投放效果跟踪 -->
<template>
<div id="effect">
	<div id="" :style="{'width':table_scroll_width + 'px',}" >
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 20px;z-index: 5;background-color: #fff;padding: 20px 20px 5px;margin-bottom: 15px;">
		<!-- 标题 -->
		<div class="page-title" style="margin-bottom: 10px;">新投放效果跟踪</div>
		
		<a-row type="flex" justify="start">
		    <a-col :span="22">
			<a-row type="flex" justify="start" style="align-items: center;">
				<a-col :span="6" class="margin-bottom-15">
					<a-row type="flex" align="middle">
						<a-col :span="col_left_span" class="col-left-label">推广日期</a-col>
						<a-col :span="col_content_span" class="padding-right-15">
							<a-range-picker style="width:100%" @change="onChangeDate" :allowClear="false"
							:locale="locale" 
							:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
						</a-col>
					</a-row>
				</a-col>
				
				<a-col :span="6" class="margin-bottom-15">
					<a-row type="flex" align="middle">
						<a-col :span="col_left_span" class="col-left-label">渠道内容</a-col>
						<a-col :span="col_content_span" class="padding-right-15">
							
							<a-select
								mode="multiple"
								style="width: 100%"
								placeholder="请选择渠道内容"
								@change="handleChangeQ"
								:filter-option="filterOption"
								:getPopupContainer="getsPopupContainer"
								allowClear
							  >
								<a-select-option v-for="(value,key) in filterList.content_channel.list" :key="key" :value="key">
								  {{value}}
								</a-select-option>
							</a-select>
						</a-col>
					</a-row>
				</a-col>
				
				<a-col :span="6" class="margin-bottom-15">
					<a-row type="flex" align="middle">
						<a-col :span="col_left_span" class="col-left-label">H5书城渠道</a-col>
						<a-col :span="col_content_span" class="padding-right-15">
							<a-select
								mode="multiple"
								style="width: 100%;"
								placeholder="请选择H5书城渠道"
								@change="handleChangeF"
								:filter-option="filterOption"
								:getPopupContainer="getsPopupContainer"
								:value="r_channel_id"
								allowClear
							  >
								<a-select-option v-for="(value,key) in filterList.gzh_channel.list" :key="key" :value="key">
								  {{value}}
								</a-select-option>
							</a-select>
						</a-col>
					</a-row>
				</a-col>
				
				<a-col :span="6" class="margin-bottom-15">
				  <a-row type="flex" align="middle">
					<a-col :span="col_left_span" class="col-left-label">公众号</a-col>
					<a-col :span="col_content_span" class="padding-right-15">
						<!-- <moreSelect
						 page_type="effectB"
						 ref="getGzhSelect"
						:placeholder="'请选择公众号'"
						:select_mode="'multiple'"
						@handleChangeSelect="handleChangeGzh"
						></moreSelect> -->
						<!-- <kyyLinkSelect page_type="effectB" ref="getGzhLink" @handleChangeSelect="handleChangeGzh"></kyyLinkSelect> -->
						<searchLinkSelect page_type="effectB" ref="getGzhLink" @handleChangeSelect="handleChangeGzh"></searchLinkSelect>
					</a-col>
				  </a-row>
				</a-col>
				
				<a-col :span="6" class="margin-bottom-15">
				  <a-row type="flex" align="middle">
					<a-col :span="col_left_span" class="col-left-label">快应用渠道</a-col>
					<a-col :span="col_content_span" class="padding-right-15">
						<a-select
							style="width: 100%"
							placeholder="请选择快应用渠道"
							@change="handleChangeY"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
						  >
							<a-select-option v-for="(value,key) in filterList.qk_channel_new.list" :key="key" :value="key">
							  {{value}}
							</a-select-option>
						</a-select>
					</a-col>
				  </a-row>
				</a-col>
				
				<a-col :span="6" class="margin-bottom-15">
				  <a-row type="flex" align="middle">
					<a-col :span="col_left_span" class="col-left-label">快应用推广链接</a-col>
					<a-col :span="col_content_span" class="padding-right-15">
						<!-- <kyyLinkSelect page_type="effectB" ref="getKyyLink" @handleChangeSelect="handleChangeS"></kyyLinkSelect> -->
						<searchLinkSelect no_found_text="请先选择快应用渠道" page_type="effectB" ref="getKyyLink" @handleChangeSelect="handleChangeS"></searchLinkSelect>
					</a-col>
				  </a-row>
				</a-col>
				
				<a-col :span="6" class="margin-bottom-15">
				  <a-row type="flex" align="middle">
					<a-col :span="col_left_span" class="col-left-label">小程序渠道</a-col>
					<a-col :span="col_content_span" class="padding-right-15">
						<a-select
							mode="multiple"
							style="width: 100%"
							placeholder="请选择小程序渠道"
							@change="handleChangeV"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
						  >
							<!-- <a-select-option v-for="(value,key) in filterList.vd_channel.list" :key="key" :value="key">
							  {{value}}
							</a-select-option> -->
							<a-select-option v-for="(value,key) in zhChannelSelect" :key="key" :value="key">
							  {{value}}
							</a-select-option>
						</a-select>
					</a-col>
				  </a-row>
				</a-col>
				
				<a-col :span="6" class="margin-bottom-15">
				  <a-row type="flex" align="middle">
					<a-col :span="col_left_span" class="col-left-label">小程序</a-col>
					<a-col :span="col_content_span" class="padding-right-15">
						<!-- <a-select
							style="width: 100%"
							placeholder="请选择小程序"
							@change="handleChangeXCX"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
						  >
							<a-select-option value="1">
								小程序1
							</a-select-option>
						</a-select> -->
						<xcxSearchSelect ref="getXcxSelect" :s_width="'100%'" @handleChangeSelect="handleChangeXCX"></xcxSearchSelect>
					</a-col>
				  </a-row>
				</a-col>
				
				<a-col :span="6" class="margin-bottom-15">
					<a-row type="flex" align="middle">
						<a-col :span="col_left_span" class="col-left-label">小程序推广链接</a-col>
						<a-col :span="col_content_span" class="padding-right-15">
							
							<searchLinkSelect page_type="effectB" ref="videLinkeSelect" @handleChangeSelect="handleChangeX"></searchLinkSelect>
						</a-col>
					</a-row>
				</a-col>
				
				<!-- <a-col :span="6" class="margin-bottom-15">
				  <a-row type="flex" align="middle">
					<a-col :span="col_left_span" class="col-left-label">小说小程序渠道</a-col>
					<a-col :span="col_content_span" class="padding-right-15">
						<a-select
							mode="multiple"
							style="width: 100%"
							placeholder="请选择小说小程序渠道"
							@change="handleChangeXS"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
						  >
							<a-select-option v-for="(value,key) in filterList.mp_book_channel.list" :key="key" :value="key">
							  {{value}}
							</a-select-option>
						</a-select>
					</a-col>
				  </a-row>
				</a-col> -->
				
				<!-- <a-col :span="6" class="margin-bottom-15">
					<a-row type="flex" align="middle">
						<a-col :span="col_left_span" class="col-left-label">小说小程序推广链接</a-col>
						<a-col :span="col_content_span" class="padding-right-15">
							
							<searchLinkSelect page_type="effectB" ref="xsXcxSelect" @handleChangeSelect="handleChangeXsLink"></searchLinkSelect>
						</a-col>
					</a-row>
				</a-col> -->
				
				<a-col :span="6" class="margin-bottom-15">
					<a-row type="flex" align="middle">
						<a-col :span="col_left_span" class="col-left-label">推广作品</a-col>
						<a-col :span="col_content_span" class="padding-right-15">
							<putBookSelect page_type="effectB" style="width: 100%;" ref="getPutBook" @handleChangeSelect="handleChangeB"></putBookSelect>
						</a-col>
					</a-row>
				</a-col>
				  
				<a-col :span="6" class="margin-bottom-15">
				  <a-row type="flex" align="middle">
					<a-col :span="col_left_span" class="col-left-label">作品频道</a-col>
					<a-col :span="col_content_span" class="padding-right-15">
						<a-select :value="r_book_type" style="width: 100%;"
						 @change="handleChangeC" 
						 :getPopupContainer="getsPopupContainer">
							<a-select-option  v-for="(item,index) in filterList.book_type.list" :key="index" :value="item.key">
								{{item.value}}
							</a-select-option>
							  
						</a-select>
					</a-col>
				  </a-row>
				</a-col>
				
				<a-col :span="6" class="margin-bottom-15">
				  <a-row type="flex" align="middle">
					<a-col :span="col_left_span" class="col-left-label">作品分类</a-col>
					<a-col :span="col_content_span" class="padding-right-15">
						<a-select
							mode="multiple"
							style="width: 100%"
							placeholder="请选择作品分类"
							@change="handleChangeZ"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
						  >
							<a-select-option v-for="(item,index) in filterList.book_category.list" :key="item.key" :value="item.key" :title="item.value">
							  {{item.value}}
							</a-select-option>
						</a-select>
					</a-col>
				  </a-row>
				</a-col>
				
				<a-col :span="6" class="margin-bottom-15">
					<a-row type="flex" align="middle">
						<a-col :span="col_left_span" class="col-left-label">推广媒体</a-col>
						<a-col :span="col_content_span" class="padding-right-15">
							<a-select
								mode="multiple"
								style="width: 100%"
								placeholder="请选择推广媒体"
								@change="handleChangeE"
								:filter-option="filterOption"
								:getPopupContainer="getsPopupContainer"
								allowClear
							  >
								<a-select-option v-for="(item,index) in filterList.media_id.list" :key="index" :value="item.key">
								  {{item.value}}
								</a-select-option>
							</a-select>
						</a-col>
					</a-row>
				</a-col>
				
				<a-col v-show="Object.keys(filterList.op_id).length > 0" :span="6" class="margin-bottom-15">
					<a-row type="flex" align="middle">
						<a-col :span="col_left_span" class="col-left-label">投手</a-col>
						<a-col :span="col_content_span" class="padding-right-15">
							<a-select
								mode="multiple"
								style="width: 100%"
								placeholder="请选择投手"
								@change="handleChangeA"
								:value="r_put_user_id"
								:filter-option="filterOption"
								:getPopupContainer="getsPopupContainer"
								allowClear
							  >
								<a-select-option v-for="(item,index) in filterList.op_id.list" :key="index" :value="item.key" >
								  {{item.value}}
								</a-select-option>
							</a-select>
						</a-col>
					</a-row>
				</a-col>
				
				<a-col :span="6" class="margin-bottom-15">
				  <a-row type="flex" align="middle">
					<a-col :span="col_left_span" class="col-left-label">留存汇总方式</a-col>
					<a-col :span="col_content_span" class="padding-right-15">
						<a-select :value="r_show_type" style="width: 100%;"
						 @change="handleChangeL" 
						 :getPopupContainer="getsPopupContainer">
							<a-select-option  v-for="(item,index) in filterList.show_type.list" :key="index" :value="item.key">
								{{item.value}}
							</a-select-option>
							  
						</a-select>
					</a-col>
				  </a-row>
				</a-col>
				
				<a-col :span="6" class="margin-bottom-15">
					<a-tooltip placement="bottom">
						<template slot="title" >
							最多180天
						</template>
						<a-row type="flex" align="middle">
							  <a-col :span="col_left_span" class="col-left-label">留存数据天数</a-col>
							  <a-col :span="col_content_span" class="padding-right-15">
								<a-input v-model="r_show_day" placeholder="请输入" type="number" @change="showDayInput" style="width: 100%;"  />
							  </a-col>
						</a-row>
					</a-tooltip>
				</a-col>
				
				<a-col :span="6"  class="margin-bottom-15" v-if="filterList.hasOwnProperty('has_money') && (role_control.includes(1) || role_control.includes(3))">
				  <a-row type="flex" align="middle">
					<a-col :span="col_left_span" class="col-left-label">数据筛选</a-col>
					<a-col :span="col_content_span" class="padding-right-15">
						<a-select :value="r_has_money" style="width: 100%;"
						 @change="handleChangeO" 
						 :getPopupContainer="getsPopupContainer">
							<a-select-option  v-for="(item,index) in filterList.has_money.list || []" :key="index" :value="item.key">
								{{item.name}}
							</a-select-option>
							  
						</a-select>
					</a-col>
				  </a-row>
				</a-col>
				
				<a-col :span="6" class="margin-bottom-15">
					<a-row type="flex" align="middle">
						<a-col :span="col_left_span" class="col-left-label">数据录入状态</a-col>
						<a-col :span="col_content_span" class="padding-right-15">
							<a-select
								style="width: 100%;"
								placeholder="请选择数据录入状态"
								@change="handleChangeLR"
								:filter-option="filterOption"
								:getPopupContainer="getsPopupContainer"
								allowClear
								showSearch
							  >
								<template v-if="filterList.hasOwnProperty('has_record') && Object.keys(filterList.has_record).length > 0">
									<a-select-option v-for="(item,index) in filterList.has_record.list || []" :key="item.key" :value="item.key">
									  {{item.name}}
									</a-select-option>
								</template>
							</a-select>
						</a-col>
					</a-row>
				</a-col>
			</a-row>
			<!-- <a-row type="flex" justify="center" style="align-items: center;">
				展开
			</a-row> -->
			</a-col>
			<a-col :span="2" style="display: flex;flex-direction: column;align-items: center;">
				<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" class="margin-bottom-15">搜索</a-button>
				<a-button @click="exportButton" type="primary" icon="download" class="margin-bottom-15">导出</a-button>
				<a-button @click="addListButton" icon="plus" style="background-color: #67c23a;border-color: #67c23a;" type="primary">新增</a-button>
			</a-col>
		</a-row>
	</div>
	</div>
	
	
	<!-- 新增的侧边栏 -->
	<a-drawer
	      title="新增"
		  width="700px"
	      placement="right"
	      :closable="false"
	      :visible="visible"
	      @close="onCloseDrawer"
	    >
			<div style="padding: 10px;">
				<div class="form-cell-box">
					<div class="class-title">投放日期</div>
						
					<a-date-picker :value="moment(x_put_date, 'YYYY-MM-DD')" 
					 style="width:400px" @change="onAddChange" 
					 :allowClear="false" placeholder="选择投放日期" 
					  :disabledDate="disabledDate"/>
				</div>
				
				<div class="form-cell-box">
					<div class="class-title">渠道内容</div>
						
					<div style="width: 400px;">
						<a-select
						:value="x_content_channel"
							style="width: 100%"
							placeholder="请选择渠道内容"
							@change="handleChangeW"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
						  >
							<a-select-option v-for="(value,key) in filterList.content_channel.list" :key="key" :value="key">
							  {{value}}
							</a-select-option>
						</a-select>
					</div>
					
				</div>
				
				<div class="form-cell-box">
					<div class="class-title">渠道</div>
						
					<!-- <a-select :value="x_channel_id" 
					 style="width: 400px" 
					 placeholder="未选择"
					 :filter-option="filterOption"
					 @change="handleChangeH" 
					 showSearch 
					>
						<a-select-option  v-for="(item,index) in filterList.channel_id.list" :key="item.key" :value="item.key">
							{{item.value}}
						</a-select-option>
					</a-select> -->
					
					<div v-if="x_content_channel == '1'" style="width: 400px;">
						<a-select
							style="width: 100%;"
							placeholder="请选择H5书城渠道"
							@change="handleChangeH"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
							:value="x_channel_id"
						  >
							<a-select-option v-for="(value,key) in filterList.gzh_channel.list" :key="key" :value="key">
							  {{value}}
							</a-select-option>
						</a-select>
					</div>
					
					<div v-else-if="x_content_channel == '2'" style="width: 400px;">
						<a-select
							style="width: 100%"
							placeholder="请选择快应用渠道"
							@change="handleChangeT"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
							:value="x_channel_id"
						  >
							<a-select-option v-for="(value,key) in filterList.qk_channel_new.list" :key="key" :value="key">
							  {{value}}
							</a-select-option>
						</a-select>
					</div>
					
					<div v-else-if="x_content_channel == '3'" style="width: 400px;">
						<a-select
							style="width: 100%"
							placeholder="请选择短剧渠道"
							@change="handleChangeR"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
							:value="x_channel_id"
						  >
							<a-select-option v-for="(value,key) in filterList.vd_channel.list" :key="key" :value="key">
							  {{value}}
							</a-select-option>
						</a-select>
					</div>
					
					<div v-else-if="x_content_channel == '4'" style="width: 400px;">
						<a-select
							style="width: 100%"
							placeholder="请选择小说小程序渠道"
							@change="handleDrawerXS"
							:filter-option="filterOption"
							:getPopupContainer="getsPopupContainer"
							allowClear
							:value="x_channel_id"
						  >
							<a-select-option v-for="(value,key) in filterList.mp_book_channel.list" :key="key" :value="key">
							  {{value}}
							</a-select-option>
						</a-select>
					</div>
					
					<div v-else style="width: 400px;">
						请先选择渠道内容↑
					</div>	
				</div>
				
				<div v-if="x_content_channel == '1'" class="form-cell-box">
					<div class="class-title">公众号</div>
						
					<a-select :value="x_gzh_id" 
					 style="width: 400px" 
					 placeholder="未选择" 
					 notFoundContent="没有内容,请先选择书城渠道" 
					 :filter-option="filterOption"
					 @change="handleChangeI"
					 showSearch 
					  >
						<a-select-option  v-for="(item,index) in xz_gzh_data" :key="item.id" :value="item.id" >
							{{item.text}}
						</a-select-option>
					</a-select>
				</div>
				<div v-else-if="x_content_channel == '2'" class="form-cell-box">
					<div class="class-title">快应用推广链接</div>
					<div style="width: 400px" >
						<searchLinkSelect no_found_text="请先选择对应渠道" page_type="effectB" mode_type="dan" ref="getKyyLink" @handleChangeSelect="handleChangeI"></searchLinkSelect>
					</div>
				</div>
				<div v-else-if="x_content_channel == '3'" class="form-cell-box">
					<div class="class-title">短剧推广链接</div>
					<div style="width: 400px" >
						<searchLinkSelect no_found_text="请先选择对应渠道" page_type="effectB" mode_type="dan" ref="videLinkeSelect" @handleChangeSelect="handleChangeI"></searchLinkSelect>
					</div>
				</div>
				<div v-else-if="x_content_channel == '4'" class="form-cell-box">
					<div class="class-title">小说小程序推广链接</div>
					<div style="width: 400px" >
						<searchLinkSelect no_found_text="请先选择对应渠道" page_type="effectB" mode_type="dan" ref="xsXcxSelect" @handleChangeSelect="handleChangeI"></searchLinkSelect>
					</div>
				</div>
				
				<div v-if="x_content_channel" class="form-cell-box">
					<div class="class-title">投放作品</div>
					
					<!-- <putBookS ref="getPutBookS" @handleChangeSelect="handleChangek"></putBookS> -->
					<tfBookSelect ref="getTfBook" s_width="400px" @handleChangeSelect="handleChangek"></tfBookSelect>
				</div>
				
				<div class="form-cell-box">
					<div class="class-title">推广媒体</div>
						
					<a-select :value="x_media_id" 
					 style="width: 400px" 
					 placeholder="未选择" 
					 :filter-option="filterOption" 
					 @change="handleChangej" 
					 showSearch
					 >
						<a-select-option  v-for="(item,index) in filterList.media_id.list" :key="index" :value="item.key">
							{{item.value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="form-cell-box">
					<div class="class-title">投放金额</div>
						
					<a-input v-model="x_input_money" placeholder="请输入" type="number" style="width: 400px;" prefix="￥" suffix="元" />
				</div>
				
				<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
				
				<div class="form-cell-box" style="margin-top: 30px;">
					<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
					<a-button @click="onCloseDrawer">取消</a-button>
				</div>
			</div>
			
			
			
	</a-drawer>
	
	<div style="background-color: #fff;padding-bottom: 30px;" :style="{'width': table_scroll_width + 'px'}">
		<TableEffect @table-th-click="tableThClick" @edit-table-cell="editTableCell" :rableTitle="rableTitle"  :tableShowData="tableShowData" 
		 :tableTotalData="tableTotalData" :table_scroll_width="table_scroll_width" 
		  :show_day_control="show_day_control" :day_week_control="day_week_control" 
		  :day_week_width="day_week_width"></TableEffect>
		  
		<div :style="{'width': table_scroll_width + 'px'}" style="position: relative;">
			<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;position: sticky;left: 20px;"
			:style="{'width': body_width - 60 + 'px'}">
				<a-icon style="font-size: 70px;color: #999;" type="file-search" />
				
				<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
			</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="body_width - 60"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
		
	</div>
	
	<a-modal
	      :title="edit_modal_title"
	      :visible="edit_visible"
	      :confirm-loading="confirmLoading"
		  cancelText="取消"
		  okText="确认" 
	      @ok="handleOk"
	      @cancel="handleCancel"
	    >
	    <a-select v-if="edit_modal_title.indexOf('投放渠道') > -1" :value="m_media_id" @change="handleChangeMA" style="width: 300px;font-size: 13px;" >
	        <a-select-option v-for="(item,index) in filterList.media_id.list" :key="index" :value="item.key">
	          {{item.value}}
	        </a-select-option>
	    </a-select>
		  
		<a-input v-else-if="edit_modal_title.indexOf('投放金额') > -1" v-model="m_put_money" placeholder="请输入" type="number"  style="width: 300px;"  />
		
		<putBookS v-else-if="edit_modal_title.indexOf('书籍选择') > -1" ref="getPutBookS" @handleChangeSelect="handleChangeMB"></putBookS>
		
		<a-input v-else-if="edit_modal_title.indexOf('新增粉丝') > -1" v-model="m_sub_num" placeholder="请输入" type="number"  style="width: 300px;"  />
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import { putDataMenu, effectBList, effectReceiveChannel, effectInfo, effectUpdate, effectNewExport, bookPutList} from '@/request/api'
import TableEffect from '@/components/putDataTable/TableEffectB.vue'
import moreSelect from '@/components/selectCompont/moreSelect.vue'
import kyyLinkSelect from './components/kyyLinkSelect.vue'
import searchLinkSelect from './components/searchLinkSelect.vue'
import tfBookSelect from '@/components/selectCompont/tfBookSelect.vue'

import putBookSelect from './components/putBookSelect.vue'
import putBookS from './components/putBookS.vue'
import videLinkeSelect from './components/videLinkeSelect.vue'

import xcxSearchSelect from '@/components/selectCompont/xcxSearchSelect.vue'
export default {
	name: 'effectB_',
	components: {
		TableEffect,moreSelect,kyyLinkSelect,putBookSelect,putBookS,videLinkeSelect,searchLinkSelect,tfBookSelect, xcxSearchSelect
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2020-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			search_button_loading: false, // 搜索按钮的加载状态
			filterList: { // 搜索条件内容
				media_id:{},
				book_id:{},
				op_id:{},
				channel_id: {},
				gzh_id: {},
				book_type: {},
				show_type: {},
				qk_channel: {},
				gzh_channel: {},
				book_category: {},
				content_channel: {},
				vd_channel: {},
				qk_channel_new: {},
				mp_book_channel: {},
				
				has_record: {}, // 数据录入状态
			}, 
			sortList: { // 搜索条件内容，另一部分
				sort_key: {},
				sort_opt: {},
			},
			r_put_user_id: [], // 投手
			r_put_book: [], // 投放书籍
			r_media_id: [], // 媒体渠道
			r_channel_id: [], // 书城
			r_gzh_id: [], // 公众号
			r_book_type: 0, // 频道
			r_show_type: "daily", // 展示维度
			r_show_day: 30, // 展示天数
			r_show_week: 8, // 展示周
			r_sort_key: "", // 排序字段
			r_sort_opt: "", // 排序方式
			r_has_money: 1, // 有投放或充值
			r_page: 1, // 页数
			r_limit: 100, // 每页多少条
			r_qk_channel_id: [], // 快应用书城id
			r_qk_url: [], // 选择的快应用推广链接
			r_book_category: [], // 作品分类
			r_content_type: undefined, // 渠道内容
			r_vd_channel: [], // 短剧推广链接
			r_vd_qd: [], // 短剧渠道
			r_xs_xcx_channel: [], // 小说小程序渠道
			r_xs_xcx_link: [], // 小说小程序渠道推广链接
			r_has_record: undefined, // 数据录入状态
			r_appid: undefined, // 选择小程序
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [ 
				{title:"ID",width:80, sort_status:0,type:"id",show_control: true,sort_:90, sort_control: false, }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"推广信息",width:100, sort_status:0,type:"op_name",show_control: true,sort_:89, sort_control: false, },
				{title:"推广日期",width:100, sort_status:0,type:"date_key",show_control: true,sort_:89, sort_control: true, },
				{title:"推广作品",width:125, sort_status:0,type:"put_book",show_control: true,sort_:88, sort_control: false, },
				{title:"推广媒体",width:110, sort_status:0,type:"media_name",show_control: true,sort_:87, sort_control: false, },
				{title:"投放金额",width:150, sort_status:0,type:"put_money",show_control: true,sort_:86, sort_control: true, },
				
				{title:"回本状态",width:180, sort_status:0,type:"return_all_daily",show_control: true,sort_:85, sort_control: false, },
				{title:"总充值统计",width:150, sort_status:0,type:"charge_money",show_control: false,sort_:38, sort_control: true, },
				{title:"总分成统计",width:150, sort_status:0,type:"earn_money",show_control: false,sort_:38, sort_control: false, },
				
				{title:"复充统计",width:180, sort_status:0,type:"pay_count_info",show_control: false,sort_:35, sort_control: false, },
				{title:"当天新增用户数",width:130, sort_status:0,type:"today_pay_user_num",show_control: true,sort_:39, sort_control: false, },
				
			],
			visible: false, // 新增侧边栏控制
			add_button_loading: false, // 侧边栏新增按钮的loading
			add_form_hint: "", // 侧边栏新增表单的验证提示
			// 新增侧边栏
			x_put_date:"", // 日期选择
			x_input_money: "", // 投放金额
			x_channel_id: undefined, // 书城渠道
			x_gzh_id: undefined, // 公众号
			x_media_id: undefined, // 媒体渠道
			x_book_id: undefined, // 投放书籍
			x_content_channel: undefined, // 渠道内容
			// 筛选条件盒子宽度，用于粘性定位
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_scroll_width: 1500, // 被表格撑开的实际内容宽度
			tableShowData: [], // 表格用来展示的数据
			tableTotalData: {}, // 总计，表格第一行
			show_day_control: 0, // 展示天数的控制
			day_week_control: 'daily', // daily展示天，weekly展示周
			day_week_width: 150, // 展示的单元格宽度
			is_admin: false, // 是否是超级管理员，true为超级管理员，false不是。
			// 新增侧边栏的公众号
			xz_gzh_data: [],
			edit_visible: false, // 编辑弹窗的显示
			edit_modal_title: "", // 编辑弹窗的标题
			confirmLoading: false,
			// 编辑弹窗的内容
			m_put_money: "", // 投放金额
			m_media_id: 0, // 投放渠道的id
			m_put_book_id: 0, // 书籍
			m_sub_num: 0, // 新增粉丝
			m_id: 0, // id
			m_index: 0, // 修改的表格索引
			req_data: [], // 搜索回来的全部数据
			table_total: 0, // 表格内容总数

			role_control: [], // 用户权限控制
			
			qk_url_data: [], // 选择快应用书城后获取的快应用推广链接
			
			col_left_span: 7, 
			col_content_span: 17, 
			
			zhChannelSelect: [], // 小说小程序渠道+短剧渠道合并到一起
		}
	},
	mounted(){
		let that = this
		
		document.querySelector('body').setAttribute('style', 'background:rgb(240, 242, 245)')
		
		this.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		that.table_scroll_width = document.body.scrollWidth - 60 // 获取表格内容的宽度
		// console.log('document.body.clientWidth',that.body_width,that.table_scroll_width)
		
		// 获取30天前日期
		that.startTime = this.$getBeforeDay(29)
		// that.startTime = this.$getThisDay()
		// 获取当前日期
		that.endTime = this.$getThisDay()
		that.x_put_date = that.endTime
		
		// 获取角色权限
		that.role_control = JSON.parse(localStorage.getItem("role_limits"))
		// console.log("role_limits", JSON.parse(localStorage.getItem("role_limits")));
		
		// 获取小程序下拉
		this.$refs.getXcxSelect.getSelectData()
		
		putDataMenu().then(res=>{
			console.log('putDataMenu',res)
			if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
				that.filterList = res.data.data.filter
				
				let f_select = res.data.data.filter
				that.zhChannelSelect = { ...f_select.vd_channel.list, ...f_select.mp_book_channel.list }
				
				// that.$refs.getGzhSelect.getSelectData(that.filterList.gzh_id.list || [])
				
				that.$refs.getPutBook.getSelectData(that.filterList.book_id.list || [])
				
				that.sortList = res.data.data.sort
				let f_data = res.data.data.filter
				let s_data = res.data.data.sort
				// console.log('f_data',f_data.book_type.list[0].key)
				that.r_book_type = f_data.book_type.list[0].key, // 频道
				that.r_show_type = f_data.show_type.list[0].key, // 展示维度
				that.r_sort_key = s_data.sort_key.list[0].key, // 排序字段
				that.r_sort_opt = s_data.sort_opt.list[0].key // 排序方式

				// 超级管理、投放管理可以有公众号、投手、有投放或充值
				// if(that.role_control.includes(1) || that.role_control.includes(3)){
				// 	that.r_has_money = f_data.has_money.list[0].key || "" // 有投放或充值。避免报错，加了过滤判断
				// }

				that.is_admin = res.data.data.is_admin
				
				// 根据权限处理表格
				if(that.is_admin){
					that.rableTitle.forEach(res=>{
						res.show_control = true
					})
					
					// 根据展示内容的不同，要对内容宽度进行处理
					let nnn = 30 // 边距
					that.rableTitle.forEach((res,index)=>{
						if(res.show_control){
							nnn += res.width
						}
					})
					that.table_scroll_width = nnn 
				}
				
				
				// 搜索
				that.searchButton()
				
				that.$nextTick(()=>{
					try{
						that.$refs.getGzhLink.getSelectData('',1)
					}catch(e){
						
					}
					try{
						that.$refs.videLinkeSelect.getSelectData('', 3)
					}catch(e){
						
					}
					try{
						that.$refs.xsXcxSelect.getSelectData('', 4)
					}catch(e){
						
					}
					// that.$refs.getKyyLink.getSelectData('',2)
				})
			}
			else {
				that.search_button_loading = false
				if(res.data.code === 401){ // 未登录
					localStorage.removeItem("access_token");
					that.$router.replace({name: 'login',params: {type:'not_log'}})
				}
				else {
					that.$message.error(`错误：${res.data.msg}`);
				}
			}
			// console.log("filterList.hasOwnProperty('has_money')",that.filterList.hasOwnProperty('has_money'))
		})
	},
	
	// 销毁节点之前就删除属性
	beforeDestroy() {
	    document.querySelector('body').removeAttribute('style')
	},
	methods:{
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 日期范围控制，根据权限来
		DateControl(current){
			return current && current > moment().endOf('day') || current < moment().subtract(90, 'day');
		},
		// 新增侧边栏的日期选择。设置今天以后的日期不可选
		disabledDate(current) {
		  return current && current > moment().endOf("day");
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		// 投手
		handleChangeA(value) {
		    console.log(`selected ${value}`);
			// 这里接收的value参数就是一个数组
			this.r_put_user_id = value
		},
		filterOption(input, option) {
			console.log(option.componentOptions.children[0].text);
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 投放书籍
		handleChangeB(value) {
			this.r_put_book = value
		    console.log(`selected ${value}`);
		},

		// 媒体渠道
		handleChangeE(value) {
			this.r_media_id = value
		    console.log(`selected ${value}`);
		},

		// 书城
		handleChangeF(value) {
			this.r_channel_id = value
		    console.log(`selected ${value}`);
			
			this.$refs.getGzhLink.getSelectData(value,1)
			
			let that = this
			// effectReceiveChannel({
			// 	q: value,
			// 	limit: 100,
			// 	channel_id: value,
			// }).then(res=>{
			// 	console.log("获取快应用、短剧推广链接",res)
			// 	// that.$refs.getKyyLink.getSelectData(res.data.qk_list)
			// 	// that.$refs.videLinkeSelect.getSelectData(res.data.vd_list)
			// 	// that.qk_url_data = res.data
			// })
		},

		// 公众号
		handleChangeGzh(value) {
			this.r_gzh_id = value
		    console.log(`selected ${value}`);
		},

		// 频道
		handleChangeC(value) {
			this.r_book_type = value
		    console.log(`selected ${value}`);
		},
		// 展示维度
		handleChangeL(value) {
			this.r_show_type = value
		    console.log(`selected ${value}`);
		},
		// 排序字段
		handleChangeM(value) {
			this.r_sort_key = value
		    console.log(`selected ${value}`);
		},
		// 排序方式 
		handleChangeN(value) {
			this.r_sort_opt = value
		    console.log(`selected ${value}`);
		},
		// 有投放或充值
		handleChangeO(value) {
			this.r_has_money = value
		    console.log(`selected ${value}`);
		},
		handleChangeLR(e){ // 数据录入
			this.r_has_record = e
		},
		
		// 新增侧边栏的操作
		// 书城渠道
		handleChangeH(value){
			let that = this
			this.x_channel_id = value
			console.log(`selected ${value}`);
			let r_data = {
				q:value
			}
			// 根据渠道获取公众号
			effectReceiveChannel(r_data).then(res=>{
				console.log("获取公众号",res)
				that.xz_gzh_data = res.data
			})
			
			this.$refs.getTfBook.getSelectData(value,'clear')
			
			this.x_gzh_id = undefined
			this.x_book_id = undefined
		},
		handleChangeT(e){ // 快应用渠道
			this.x_channel_id = e
			this.$refs.getKyyLink.getSelectData(e,2,'clear')
			
			this.$refs.getTfBook.getSelectData(e,'clear')
			
			this.x_gzh_id = undefined
			this.x_book_id = undefined
		},
		handleChangeR(e){ // 短剧渠道
			this.x_channel_id = e
			this.$refs.videLinkeSelect.getSelectData(e, 3,'clear')
			
			this.$refs.getTfBook.getSelectData(e,'clear')
			
			this.x_gzh_id = undefined
			this.x_book_id = undefined
		},
		// 公众号
		handleChangeI(value){
			this.x_gzh_id = value
			console.log(`selected ${value}`);
		},
		// 媒体渠道
		handleChangej(value){
			this.x_media_id = value
			console.log(`selected ${value}`);
		},
		// 投放书籍
		handleChangek(value){
			this.x_book_id = value
			console.log(`selected ${value}`);
		},
		
		// 快应用书城
		handleChangeY(e){
			let that = this
			this.r_qk_channel_id = e
			this.r_qk_url = []
			this.$refs.getKyyLink.getSelectData(e,2)
			
		},
		// 快应用推广链接
		handleChangeS(e){
			// console.log("快应用推广链接",e);
			this.r_qk_url = e
		},
		// 作品分类
		handleChangeZ(e){
			console.log("作品分类",e);
			this.r_book_category = e
		},
		// 渠道内容
		handleChangeQ(e){
			this.r_content_type = e
		},
		// 短剧推广链接
		handleChangeX(e){
			this.r_vd_channel = e
		},
		// 短剧渠道
		handleChangeV(e){
			let that = this
			that.r_vd_qd = e
			this.$refs.videLinkeSelect.getSelectData(e, 3)
			// 获取小程序下拉
			this.$refs.getXcxSelect.getSelectData(e)
		},
		handleChangeW(e){
			let that = this
			this.x_content_channel = e
			this.x_channel_id = undefined
			this.x_gzh_id = undefined
			if(this.x_content_channel == '2'){ // 快应用
				that.$nextTick(()=>{
					that.$refs.getKyyLink.clearValue()
				})
			}
			else if(this.x_content_channel == '3'){ // 短剧
				that.$nextTick(()=>{
					that.$refs.videLinkeSelect.clearValue()
				})
			}
			else if(this.x_content_channel == '4'){ // 小说小程序
				that.$nextTick(()=>{
					that.$refs.xsXcxSelect.clearValue()
				})
			}
			// 投放作品清空
			this.x_book_id = undefined
			that.$nextTick(()=>{
				that.$refs.getTfBook.clearValue()
			})
		},
		// 小说小程序渠道
		handleChangeXS(e){
			this.r_xs_xcx_channel = e
			this.$refs.xsXcxSelect.getSelectData(e, 4)
		},
		handleChangeXsLink(e){
			this.r_xs_xcx_link = e
		},
		
		handleDrawerXS(e){ // 新增侧边栏-小说小程序渠道
			this.x_channel_id = e
			this.$refs.xsXcxSelect.getSelectData(e, 4,'clear')
			this.$refs.getTfBook.getSelectData(e,'clear')
			
			this.x_gzh_id = undefined
			this.x_book_id = undefined
			
		},
		
		// 选择小程序
		handleChangeXCX(e){
			this.r_appid = e
		},
		
		// 搜索
		searchButton(type,class_,type_,){
			let that = this
			console.log("that.r_show_day",that.r_show_day || 0)
			this.search_button_loading = true
			
			if(type != '分页'){
				that.r_page = 1
			}
			
			// 展示天数控制
			if(this.r_show_day){
				this.show_day_control = Number(this.r_show_day)
			}
			else {
				this.show_day_control = 0
			}
			// 展示维度
			this.day_week_control = that.r_show_type
			
			// 表格宽度计算
			let z_w = 0
			that.rableTitle.forEach((res,index)=>{
				if(res.show_control){
					z_w = z_w + res.width
				}
			})
			if(that.r_show_type === 'daily'){
				z_w = z_w + 30 + this.day_week_width*this.show_day_control
				that.table_scroll_width = z_w
			}
			else {
				z_w = z_w + 30 + this.day_week_width*8 // 只显示8周
				that.table_scroll_width = z_w
			}
			
			
			
			// 排序
			if(class_){
				that.r_sort_opt = class_
			}
			if(type_){
				that.r_sort_key = type_
			}
			
			let r_data = {
				cur_page: that.r_page,
				per_page: that.r_limit,
				
				start_date_key: that.startTime.replace(/-/g, ''),
				end_date_key: that.endTime.replace(/-/g, ''),
				
				book_type: that.r_book_type.toString(), // 频道
				show_type: that.r_show_type, // 展示维度
				
				sort_key: that.r_sort_key, // 排序字段
				sort_opt: that.r_sort_opt, // 排序方式
				
				media_id: that.r_media_id, // 媒体渠道
				put_book: that.r_put_book, // 投放书籍
				
				book_category: that.r_book_category, // 作品分类
				
				content_type: that.r_content_type, // 渠道内容
				
				has_record: that.r_has_record, // 数据录入状态
				
				appid: that.r_appid,
			}
			
			// 三个渠道的ID合为一个
			let qd_id = []
			qd_id = qd_id.concat(that.r_channel_id)
			if(that.r_qk_channel_id){ // 因为这个快应用下拉是单选，当清除单选内容时会返回undefined或null
				qd_id = qd_id.concat(that.r_qk_channel_id)
			}
			qd_id = qd_id.concat(that.r_vd_qd)
			qd_id = qd_id.concat(that.r_xs_xcx_channel)
			r_data.channel_id = qd_id
			
			// 三个渠道下的推广链接合为一个
			let put_id = []
			put_id = put_id.concat(that.r_gzh_id)
			put_id = put_id.concat(that.r_qk_url)
			put_id = put_id.concat(that.r_vd_channel)
			put_id = put_id.concat(that.r_xs_xcx_link)
			r_data.gzh_id = put_id

			// 超级管理、投放管理可以有公众号、投手、有投放或充值。2022-11-1公众号权限放开
			if(that.role_control.includes(1) || that.role_control.includes(3)){
				// r_data.gzh_id = that.r_gzh_id, // 公众号
				r_data.has_money = that.r_has_money.toString() // 有投放或充值
			}
			// op_id字段有内容，则显示投手选择框，并且允许请求
			if(Object.keys(that.filterList.op_id).length > 0){
				r_data.put_user_id = that.r_put_user_id // 投手
			}

			console.log('搜索请求',r_data)
			if(type != '导出'){
				effectBList(r_data).then(res=>{
					console.log('搜索结果',res)
					that.search_button_loading = false
					
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('搜索成功');
						that.table_total = res.data.data.total || 0
						
						if(res.data.data.data.length === 0){
							that.tableTotalData = {}
							that.tableShowData = []
						}
						else {
							let req_data = JSON.parse(JSON.stringify(res.data.data.data))
							// console.log("req_data",req_data)
							// 总计数据的处理
							let z_data = req_data[0]
							// console.log("z_data",z_data)
							
							// 把后端返回的数据处理成表格要显示的，针对天数的处理
							function handleData(h_data,show_number){
								// console.log("show_number",show_number)
								// if(that.r_show_type === 'daily'){ // 天
									if(show_number){ // 如果有天数要显示的话
									// console.log("如果有天数要显示的话")
										if(h_data.hasOwnProperty('stats_info')){ // 有这个内容的话，就要判断哪些天是有数值的，哪些天是没有数值的
											let k_data = Object.keys(h_data.stats_info)
											let f_data = [] // 过滤出来能用的放里面
											k_data.forEach((res,indx)=>{ // 过滤，有的键名会是负值，要把负值的去掉
												if(res.indexOf("-") < 0){
													f_data.push(res)
												}
											})
											// console.log("k_data",k_data)
											// console.log("f_data",f_data)
											let nnn = Number(show_number)
											// console.log("nnn",nnn)
											// 把要放入表格显示的数据弄一份出来
											let t_data = [] // 要用来放入表格显示的内容
											for(let i = 0;i<nnn;i++){
												// console.log(333333333)
												let obj = {
													show_type_control: false, // 控制显示有内容的部分还是显示默认的充值：0，false为显示充值：0
													show_value: {}, // 为空，默认显示充值：0
												}
												t_data.push(obj)
											}
											// 然后针对有内容的天数进行处理，把对应天数的数据放进去
											t_data.forEach((res,index)=>{
												f_data.forEach((res_f,index_f)=>{
													if(res_f == index){
														// console.log(555555)
														res.show_type_control = true
														res.show_value = h_data.stats_info[res_f]
													}
												})
											})
											// console.log("t_data",t_data)
											
											// h_data.table_day = t_data
											return t_data
										}
										else { // 没有这个字段的话，直接全部显示“充值：0”
											let nnn = Number(show_number)
											// console.log("nnn",nnn)
											// 把要放入表格显示的数据弄一份出来
											let t_data = [] // 要用来放入表格显示的内容
											for(let i = 0;i<nnn;i++){
												// console.log(333333333)
												let obj = {
													show_type_control: false, // 控制显示有内容的部分还是显示默认的充值：0，false为显示充值：0
													show_value: {}, // 为空，默认显示充值：0
												}
												t_data.push(obj)
											}
											// h_data.table_day = t_data
											return t_data
										}
									}
									else { 
										// h_data.table_day = []
										return []
									}
								// }
								
							}
							
							let ss_nn 
							if(that.r_show_type === 'daily'){ 
								ss_nn = that.r_show_day
							}
							else {
								ss_nn = 8
							}
							console.log("table_day",handleData(z_data, ss_nn));
							z_data.table_day = handleData(z_data, ss_nn)
							that.tableTotalData = z_data
							
							
							
							let s_data = req_data.slice(1,req_data.length)
							
							that.req_data = s_data
							
							s_data.forEach((res,index)=>{
								res.table_day = handleData(res, ss_nn)
								// 处理第一天是否要显示“达标”、“未达标”
								// book_return_require字段和today_return_require字段好像是一样的
								if(res.today_return_require > 0){ // 先保证设置了首日roi
									//  第一天的roi 大于 作品设置的roi
									// if(z_data.table_day[0].show_value.incr > res.today_return_require){  // 达标
										if(res.is_over_roi_require){ // is_over_roi_require这个字段好像只有0、1两个值，0表示不达标。1表示达标
											res.table_day[0].db = '1' // 达标
										}
										else {
											res.table_day[0].db = '2' // 不达标
										}
										
									// }
								}
								
								// true为显示正常内容，false显示编辑操作
								// res.media_name_control = true 
								// res.put_money_control = true
								
							})
							// console.log("s_data",s_data)
							that.tableShowData = s_data
						}
					}
					else {
						that.search_button_loading = false
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
				.catch(err=>{
					that.search_button_loading = false
					that.$message.error(`错误：${err}`);
				})
			}
			else if(type == '导出'){
				// 这里是直接导出，不用加参数
				// r_data.excel_type = 1
				delete r_data.cur_page
				delete r_data.per_page
				
				effectNewExport(r_data).then(res=>{
					console.log("导出测试",res);
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
						
						that.$message.success(res.data.msg || "导出成功");
						
					}
					else {
						
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
					}
				})
			}
		},
		// 新增
		addListButton(){
			let that = this
			
			that.visible = true
			// that.$nextTick(()=>{
			// 	that.$refs.getPutBookS.getSelectData(that.filterList.book_id.list || [])
			// })
		},
		// 侧边栏删除
		onCloseDrawer(){
			// if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
			// 	return
			// }
			let that = this
			
			that.visible = false
			
			that.x_content_channel = undefined
			
			that.x_channel_id = undefined // 书城渠道
			that.x_gzh_id = undefined // 公众号
			that.x_media_id = undefined // 媒体渠道
			// that.x_book_id = undefined // 投放书籍。这个不清楚是因为用户再操作的时候会一个书籍连续新增几次，所以不清除，方便用户
			// that.$refs.getPutBookS.getEdit() // 投放书籍下拉框组件，这里面的书籍ID也要清除
			
			that.x_input_money = "" // 投放金额
			
			that.add_button_loading = false
		},
		// 新增的确认按钮
		addRequest(){
			let that = this
			// console.log('x_channel_id',this.x_channel_id);
			// console.log('x_gzh_id',this.x_gzh_id);
			// console.log('x_media_id',this.x_media_id);
			// console.log('x_book_id',this.x_book_id);
			if(!that.x_put_date){ // 没有投放日期
				that.add_form_hint = "请填写 投放日期 ！！！"
			}
			
			else if(!that.x_channel_id){ // 没有渠道
				that.add_form_hint = "请填写 渠道 ！！！"
			}
			else if(!that.x_gzh_id){ // 公众号-新增
				that.add_form_hint = "请填写 公众号/快应用推广链接/短剧推广链接"
			}
			else if(!that.x_book_id){ // 投放书籍-新增
				that.add_form_hint = "请填写 投放作品 ！！！"
			}
			else if(!that.x_media_id){ // 推广媒体-新增
				that.add_form_hint = "请填写 推广媒体 ！！！"
			}
			
			else if(that.x_input_money.length === 0){ // 投放金额-新增/编辑版
				that.add_form_hint = "请填写 投放金额 ！！！"
			}
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				let r_data = {
					channel_id: that.x_channel_id, // 书城渠道
					gzh_id: that.x_gzh_id, // 公众号
					media_id: that.x_media_id, // 媒体渠道
					date_key: that.x_put_date, // 投放日期
					put_money: that.x_input_money, // 投放金额
					put_book: that.x_book_id, // 投放书籍
				}
				effectInfo(r_data).then(res=>{
					console.log("新增",res)
					that.add_button_loading = false
					if(res.data.code == 0){
						that.$message.success('新增成功');
						that.visible = false
						
						// 清空
						that.onCloseDrawer()
						
						// 重新搜索一边
						that.searchButton()
					}
					else {
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							this.$message.error(res.data.data.message || "新增失败");
						}
					}
				})
				.catch(err=>{
					that.$message.error('新增失败，可能是网络不佳');
					that.add_button_loading = false
				})
			}
		},
		// 导出
		exportButton(){
			let that = this
			
			that.searchButton('导出')
		},
		
		// 新增的选择日期
		onAddChange(date, dateString) {
		    console.log(date, dateString);
			this.x_put_date = dateString
		},
		// 给展示天数设置最大值，位数不能超过4位，没有那么多天
		showDayInput(e){
			console.log("this.r_show_day",this.r_show_day)
			// if(this.r_show_day.length > 3){
			// 	let nn = this.r_show_day.slice(0,3)
			// 	if(Number(nn) < 180){
			// 		this.r_show_day = nn
			// 	}
			// 	else {
			// 		this.r_show_day = 180
			// 	}
			// }
			// else {
				let nn = this.r_show_day.slice(0,3) 
				if(Number(nn) < 180){
					this.r_show_day = nn || 0
				}
				else {
					this.r_show_day = 180
				}
			// }
			// console.log("this.show_day_control",this.show_day_control)
			// console.log("this.r_show_day",this.r_show_day)
		},
		
		
		// 编辑
		editTableCell(title,index,value){
			let that = this
			console.log(title)
			console.log(index)
			console.log(value)
			this.edit_modal_title = "编辑" + title
			
			that.m_index = index
			
			// 获取请求要用的id
			that.m_id = that.req_data[index].id
			
			if(title === "投放渠道"){
				
				// console.log(that.req_data)
				let z_data = that.req_data
				z_data.forEach((res_f,index_f) =>{
					if(res_f.media_name === value){
						that.m_media_id = res_f.media_id
					}
				})
			}
			else if(title === "投放金额"){
				that.m_put_money = value
				
			}
			else if(title === "书籍选择"){
				let z_data = that.req_data
				z_data.forEach((res_f,index_f) =>{
					if(res_f.put_book === value){
						that.m_put_book_id = res_f.put_book_id
					}
				})
				
			}
			else if(title === "新增粉丝"){
				that.m_sub_num = value
			}
			this.edit_visible = true;
			if(title === "书籍选择"){
				that.$nextTick(()=>{
					that.$refs.getPutBookS.getSelectData(that.filterList.book_id.list || [])
					that.$refs.getPutBookS.getEdit(that.m_put_book_id)
				})
			}
		},
		handleOk(e) {
		    let that = this
		    this.confirmLoading = true;
		    // setTimeout(() => {
		    //     this.edit_visible = false;
		    //     this.confirmLoading = false;
		    // }, 2000);
			
			let r_data = {
				id: that.m_id
			}
			
			
			if(that.edit_modal_title.indexOf('投放金额') > -1){
				
				r_data.put_money = that.m_put_money
			}
			else if(that.edit_modal_title.indexOf('新增粉丝') > -1){
				
				r_data.sub_num = that.m_sub_num
			}
			else if(that.edit_modal_title.indexOf('投放渠道') > -1){
				
				r_data.media_id = that.m_media_id
			}
			else if(that.edit_modal_title.indexOf('书籍选择') > -1){
				
				r_data.put_book = that.m_put_book_id
			}
			
			effectUpdate(r_data).then(res=>{
				console.log("修改結果",res)
				
				
				if(that.edit_modal_title.indexOf('投放金额') > -1){
					that.tableShowData[that.m_index].put_money = that.m_put_money
					this.$message.success('编辑成功');
					// 重新搜索一边。因为这里更新的不光是投放金额的数据，还有充值信息的数据。充值信息的数据是要经过后端那边计算的。计算规则我并不知道
					// that.searchButton()
				}
				else if(that.edit_modal_title.indexOf('新增粉丝') > -1){
					that.tableShowData[that.m_index].sub_num = that.m_sub_num
				}
				else if(that.edit_modal_title.indexOf('投放渠道') > -1){
					that.filterList.media_id.list.forEach((res,index)=>{
						if(res.key === that.m_media_id){
							console.log(res)
							that.tableShowData[that.m_index].media_name = res.value
							that.tableShowData[that.m_index].media_id = res.key
						}
					})
					// that.searchButton() // 后端那边有缓存，重新加载了还是旧的数据，所以干脆不刷新了。
				}
				else if(that.edit_modal_title.indexOf('书籍选择') > -1){
					// that.searchButton() // 后端那边有缓存，重新加载了还是旧的数据，所以干脆不刷新了。
					that.filterList.book_id.list.forEach((res,index)=>{
						if(res.key === that.m_put_book_id){
							console.log(res)
							that.tableShowData[that.m_index].put_book = res.value
							that.tableShowData[that.m_index].put_book_id = res.key
						}
					})
				}
				
				this.confirmLoading = false;
				this.edit_visible = false;
				// 上面的操作已经把修改后的内容放入表格了，但是因为有的数据是通过该字段计算出来的，所以要后端那边从新计算一下，就重新请求一边
				this.$nextTick(()=>{
					that.searchButton('分页')
				})
			})
		},
		handleCancel(e) {
		  console.log('Clicked cancel button');
		  if( this.confirmLoading){
			  return
		  }
		  this.edit_visible = false;
		},
		// 投放渠道-编辑
		handleChangeMA(value){
			console.log(value)
			this.m_media_id = value
			
		},
		// 书籍选择-编辑
		handleChangeMB(value){
			console.log(value)
			this.m_put_book_id = value
			
		},
		
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton('分页')
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 点击表格的表头排序
		tableThClick(index,status,type){
			let that = this
			// console.log("点击表格的表头排序",index)
			// console.log("点击表格的表头排序",status)
			console.log("点击表格的type",type)
			let ttt = type
			
			
			if(status === 1){ // desc排序，箭头向下
				console.log('desc排序，箭头向下')
				that.searchButton('排序','desc',ttt)
			}
			else if(status === 2){ // asc排序，箭头向上
				console.log('asc排序，箭头向上')
				that.searchButton('排序','asc',ttt)
			}
			else { // 默认
				that.searchButton()
			}
		},
	}
}
</script>

<style scoped>
#effect {
	background-color: rgb(240, 242, 245);
	margin: -20px -30px -30px -30px;
	padding: 20px 20px 30px 20px;
	min-height: calc(100vh - 85px);
}

.col-left-label {
	text-align: right;
	padding-right: 15px;
}
.padding-right-15 {
	padding-right: 15px;
}
.margin-bottom-15 {
	margin-bottom: 15px;
}

.class-title {
	width: 100px;
}
</style>